import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTime,
    getTodayDateISO
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollModal } from './../../../Helpers/Validation/Employees/PayrollValidation';
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllPayroll, deletePayroll } from './../../../Helpers/apiCalls/Employees/PayrollApi';
import { getAllBranches } from './../../../Helpers/apiCalls/Manage/Branches';
import { getUnfollowedBreakReport, getUnfollowedBreakReportBreakdown } from './../../../Helpers/apiCalls/Employees/SchedulerApi';

export default function UnfollowedBreakReport() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const today = new Date();
    const sevendaysago = new Date();
    sevendaysago.setDate(sevendaysago.getDate() - 7);
    const [filterConfig, setFilterConfig] = useState({
        employee_id: "",
        employee_name: "",
        date_from: sevendaysago,
        date_to: today,
        user: accountType,
    })
    const [isError, setIsError] = useState({
        employee_id: false,
        payroll_month_from: false,
        payroll_month_to: false,
    });
    const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataCsv, setAllDataCsv] = useState([]);
    const [totalNet, setTotalNet] = useState("0");
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [isClicked, setIsClicked] = useState(false);


     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     /* add modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const handleShowAddModal = () => setShowAddModal(true);
     const handleCloseAddModal = () => setShowAddModal(false); 

     const [breakdown, setBreakdown] = useState([]);
     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState({
        label: "",
        value: "",
     });
     const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
     const [selectedMonthTo, setSelectedMonthTo] = useState("");

     
     
     
    
    const excelHeaders = [
        { label: "Payroll Range", key: "payroll_range" },
        { label: "Disbursement Date", key: "disbursement_date" },
        { label: "Type", key: "disbursement_type" },
        { label: "Employee Name", key: "employee_name" },
        { label: "Department", key: "department_name" },
        { label: "Payee ID", key: "payee_id" },
        { label: "Net Pay", key: "grand_total" },
        { label: "Total Working Hours", key: "working_hours" },
        { label: "Rate", key: "rate" },
        { label: "Basic Pay", key: "basic_pay" },
        { label: "Total Wages", key: "total_addition" },
        { label: "Total Deductions", key: "total_deduction" },
        { label: "Transportation Allowance", key: "transportation_allowance" },
        { label: "Other Allowances", key: "other_allowances" },
        { label: "Holiday", key: "holidays" },
        { label: "Other Wages", key: "other_wages" },
        { label: "Philhealth", key: "philhealth" },
        { label: "SSS", key: "sss" },
        { label: "Pagibig", key: "pagibig" },
        { label: "Shortage", key: "shortage" },
        { label: "Cash Advance", key: "cash_advance" },
        { label: "Other Deductions", key: "other_deductions" },
        { label: "SSS Loan", key: "sss_loan" },
        { label: "Pagibig Loan", key: "pagibig_loan" },
        { label: "Remarks", key: "remarks" },
    ];
    
    function renderTable() {
        return (
            <Table className="align-middle">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Expected Break Start</th>
                        <th>Actual Break Start</th>
                        <th>Expected Break End</th>
                        <th>Actual Break End</th>
                    </tr>
                </thead>
                <tbody>
                    {breakdown?.map((sched) => {
                        return(
                            <tr>
                            <td>{sched.date}</td>
                            <td>{sched.time_in}</td>
                            <td>{sched.actual_timein}</td>
                            <td>{sched.time_out}</td>
                            <td>{sched.actual_timeout}</td>
                        </tr>
                        )
                    })}
                </tbody>
            </Table>
        );
    }

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleViewSched(row) {
        setSelectedRow(row)
        fetchBreakdown()
    }

    function DocBtn(row) {
        return (
            <span
                className="me-4 align-middle ps-label blue"
                onClick={() =>
                    handleViewSched(row)
                } 
            >
                {numberFormat(row.unfollowed_breaks)}
            </span>
        );
    }

    async function fetchEmployees() {
        setEmployees([])

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees([{label: "All Employees", value: ""}, ...result]);
        }
    }

    // async function fetchBranches() {
    //     setShowLoader(true);
    //     setBranches([])
    //     const response = await getAllBranches();
    //     if (response.error) {
    //     } else {
    //         var allBranches = response.data.data.data
    //         .filter((data) => {
    //             return data.is_franchise === "0"
    //         })
    //         .map((data) => {
    //             var branch = data;
    //             branch.label = data.name
    //             branch.value = data.id
    //             return branch;
    //         });
    //         setBranches([{label: "All Branches", value:""}, ...allBranches]);
    //     }
    //     setShowLoader(false);
    // }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalNet("0")

        const response = await getUnfollowedBreakReport(filterConfig);
        
        if (response.error) {
            setAllData([])
        } else {
            var data = response.data.map((bill) => {
                var info = bill;
                info.unfollowed_breaks = bill.unfollowed_breaks ? numberFormat(bill.unfollowed_breaks) : ""
                return info;
            });
            setAllData(data)

        }
        setShowLoader(false);
    }

    async function fetchBreakdown() {
        setBreakdown([])

        const response = await getUnfollowedBreakReportBreakdown(filterConfig, selectedRow.employee_id);
        
        if (response.error) {
            setBreakdown([])
            
            toast.error(response.error.response.data.messages.error, {
                style: toastStyle(),
            });
        } else {
            var data = response.data.map((bill) => {
                var info = bill;
                info.date = bill.actual_timein ? Moment(bill.actual_timein).format("MMM DD, YYYY") : ""
                info.time_in = bill.time_in ? getTime(bill.time_in) : ""
                info.actual_timein = bill.actual_timein ? getTime(bill.actual_timein) : ""
                info.time_out = bill.time_out ? getTime(bill.time_out) : ""
                info.actual_timeout = bill.actual_timeout ? getTime(bill.actual_timeout) : ""
                
                return info;
            });
            setBreakdown(data)
            handleShowAddModal()

        }
    }
    // async function handleDeleteExpense() {
    //     setIsClicked(true);
    //     const response = await deletePayroll(selectedRow.id);
    //     if (response.data) {
    //         toast.success("Payroll Deleted Successfully!", {
    //             style: toastStyle(),
    //         });
    //         setTimeout(() => refreshPage(), 1000);
    //     } else {
    //         toast.error("Error Deleting Payroll", {
    //             style: toastStyle(),
    //         });
    //     }
    // }

    React.useEffect(() => {
        fetchEmployees();
        // fetchBranches()
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"HR REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={6}>
                        <h1 className="page-title"> UNFOLLOWED BREAK REPORT </h1>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        {/* <input
                            type="text"
                            name="employee_name"
                            placeholder="Search employee name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        ></input> */}
                    </Col>
                </Row>

                {/* <Row>
                    <Col className="d-flex justify-content-end mb-4">
                        <div className="justify-content-center align-items-center ">
                            <CSVLink
                                className="button-primary px-3 py-3 justify-content-center align-items-center download-csv"
                                data={allData}
                                headers={excelHeaders}
                                target="_blank"
                                filename={`${getTodayDateISO()} PayrollHistory`}
                            >
                                <span className="me-2">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download Excel
                            </CSVLink>
                        </div>
                    </Col>
                </Row> */}

                <div className="tab-content">
                    {/* filters */}
                    <div className="my-2 px-2 PO-filters d-flex">
                        <span className="me-4 align-middle mt-2 ps-label">
                            Filter By:
                        </span>

                        <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Employee"
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                borderRadius: "7px",
                                border: "0px",
                                minHeight: "20px",
                                maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                
                            }}
                            options={employees}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "employee_id": e.value };
                                });}}
                        />
                        <span className="me-4 align-middle mt-2 ps-label">
                            From:
                        </span>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={sevendaysago}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="PI-date-btn me-3 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />

                        <span className="me-4 align-middle mt-2 ps-label">
                            To:
                        </span>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="PI-date-btn me-3 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                    </div>

                    {/* <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total NET: {numberFormat(totalNet)}
                        </span>
                    </div> */}

                    <div className="below">
                        {/* table */}
                        <TableTemp
                            tableHeaders={[
                                // "-",
                                // "DATE",
                                "EMPLOYEE",
                                // "UNDERTIME",
                                "NO. OF UNFOLLOWED BREAKS",
                            ]}
                            headerSelector={[
                                // "-",
                                // "date",
                                "employee_name",
                                // "undertime",
                                "unfollowed_breaks",
                            ]}
                            tableData={allData}
                            // ViewBtn={(row) => ViewBtn(row)}
                            ContractBtn={(row) => DocBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>

            {/* modals */}
            {/* <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="payroll"
                onDelete={handleDeleteExpense}
                isClicked={isClicked}
            /> */}

            <Modal show={showAddModal} onHide={handleCloseAddModal} size="xl" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        VIEW SCHEDULE
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row className="mt-3 mb-2">
                            {/* <span className="PI-modal-label">Original Schedule</span> */}
                            <div className="print-table w-95 mt-3 mx-3">
                                {renderTable()}
                            </div>
                        </Row>
                        
                    </div>
                </Modal.Body>
                <Modal.Footer className="PI-modal-buttons">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary"
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
